import {BaseConverter} from '../../base/converters/base-converter.converter';

import {OrdersResearchFilterConverter} from './orders-research-filter.converter';
import {OrdersResearchOptionsConverter} from './orders-research-options.converter';
import {Injectable} from '@angular/core';
import {PaginationConverter} from './pagination.converter';
import {OrdersResearchModel} from '../models/orders-research.model';
import {OrdersResearch} from '../../shared/DTO/ordersResearch';

@Injectable()
export class OrdersResearchConverter extends BaseConverter<OrdersResearchModel, OrdersResearch> {

  constructor(private ordersResearchFilterConverter: OrdersResearchFilterConverter,
              private paginationConverter: PaginationConverter) {
    super();
  }

  convertToDto(model: OrdersResearchModel): OrdersResearch {
    if (!model) {
      return undefined;
    }
    return {
      filter: this.ordersResearchFilterConverter.convertToDto(model.filter),
      pagination: this.paginationConverter.convertToDto(model.pagination)
    };
  }

  convertToModel(dto: OrdersResearch): OrdersResearchModel {
    if (!dto) {
      return null;
    }

    let model: OrdersResearchModel = new OrdersResearchModel();

    model.filter = this.ordersResearchFilterConverter.convertToModel(dto.filter);
    model.pagination = this.paginationConverter.convertToModel(dto.pagination);
    return model;
  }

}
